import { CookieConsentState } from '../../hooks/useCookieConsent';

// Google Analytics configuration
const GA_TRACKING_ID = 'G-1SF2LTKSVP';

export const loadAnalyticsIfConsented = (consentState: CookieConsentState) => {
  if (!consentState.analytics) {
    return;
  }

  // Load Google Analytics
  loadGoogleAnalytics();
  
  // Load other analytics services here if needed
  // loadFacebookPixel();
  // loadHotjar();
};

export const clearAnalyticsCookies = () => {
  // Clear Google Analytics cookies
  clearGoogleAnalyticsCookies();
  
  // Clear other analytics cookies here if needed
  // clearFacebookPixelCookies();
  // clearHotjarCookies();
};

export const trackPageView = (path: string) => {
  if (typeof window.gtag !== 'function') {
    return;
  }
  window.gtag('event', 'page_view', {
    page_title: document.title,
    page_location: `${window.location.origin}${path}`,
    page_path: path,
  });
};

const loadGoogleAnalytics = () => {
  // Check if GA is already loaded
  if (typeof window.gtag === 'function') {
    return;
  }

  // Create gtag function
  window.dataLayer = window.dataLayer || [];
  window.gtag = function() {
    window.dataLayer.push(arguments);
  };
  window.gtag('js', new Date());
  window.gtag('config', GA_TRACKING_ID, {
    page_title: document.title,
    page_location: window.location.href,
  });

  // Load Google Analytics script
  const script = document.createElement('script');
  script.async = true;
  script.src = `https://www.googletagmanager.com/gtag/js?id=${GA_TRACKING_ID}`;
  document.head.appendChild(script);
};

const clearGoogleAnalyticsCookies = () => {
  // Clear GA cookies
  const cookies = document.cookie.split(';');
  
  cookies.forEach(cookie => {
    const [name] = cookie.split('=');
    const trimmedName = name.trim();
    
    if (trimmedName.startsWith('_ga') || 
        trimmedName.startsWith('_gid') || 
        trimmedName.startsWith('_gat') ||
        trimmedName === 'AMP_TOKEN' ||
        trimmedName === '_gac_') {
      document.cookie = `${trimmedName}=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;`;
    }
  });
};

// TypeScript declarations for global objects
declare global {
  interface Window {
    gtag: (...args: any[]) => void;
    dataLayer: any[];
  }
} 